import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { FINAL_CTA } from "../data/content";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="grain relative overflow-hidden border-t border-white/10">
    <div className="absolute inset-0" aria-hidden="true">
      <img src={FINAL_CTA.image} alt="" loading="lazy" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/60" />
    </div>
    <div className="relative z-10 mx-auto max-w-4xl px-6 py-32 text-center md:py-44">
      <Reveal>
        <h2 className="font-serif text-4xl font-medium leading-tight tracking-tight text-white md:text-6xl">
          Your Vision. Our Craftsmanship. <span className="text-gold">Your Legacy.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-gray-300 md:text-lg">
          From renovations to custom-built homes, let's create something made to last.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <a
          href="#contact"
          data-testid="final-cta-button"
          className="group mt-12 inline-flex items-center gap-3 bg-gold px-10 py-4 font-accent text-xs font-semibold uppercase tracking-[0.3em] text-black transition-colors duration-300 hover:bg-gold-hover focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-black"
        >
          Start Your Project
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
        </a>
      </Reveal>
    </div>
  </section>
);
